import { useQuery } from "@tanstack/react-query";
import { onlineUsersQueryOptions } from "@/shared/api/onlineUsers";

interface OnlineUsersIndicatorProps {
  className?: string;
}

export const OnlineUsersIndicator: React.FunctionComponent<
  OnlineUsersIndicatorProps
> = ({ className }: OnlineUsersIndicatorProps) => {
  const { data } = useQuery(onlineUsersQueryOptions());
  const count =
    !data || !Number.isFinite(data.count) || data.count < 0
      ? null
      : Math.floor(data.count);
  return <OnlineUsersIndicatorView className={className} count={count} />;
};

export const OnlineUsersIndicatorView: React.FunctionComponent<
  OnlineUsersIndicatorProps & { count: number | null }
> = ({ className, count }) => {
  if (count === null) return null;
  return (
    <output className={className} aria-live="polite">
      現在{count}人くらいが見てます。
    </output>
  );
};
